import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { ConfigProvider } from "antd";
import { fetchBrandSettings } from "../Store/brandSlice";
import customizeRenderEmpty from "./Common/Common/RenderEmpty";

/** Fixed app theme — not driven by brand-settings API colors. */
const APP_THEME = {
  token: {
    colorPrimary: "#005B60",
    colorLink: "#005B60",
    colorInfo: "#005B60",
    colorError: "#D1133E",
  },
};

/**
 * Fetches brand settings for consumers that only need the API (e.g. sidebar `logoUrl`).
 * Does not apply remote colors, favicon, or document title.
 */
const BrandProvider = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchBrandSettings());
  }, [dispatch]);

  return (
    <ConfigProvider renderEmpty={customizeRenderEmpty} theme={APP_THEME}>
      {children}
    </ConfigProvider>
  );
};

export default BrandProvider;
